import React, { useEffect } from "react";
import M from "materialize-css";
import Header from "./Header";
import { Link } from "react-router-dom";

export default function Fotos(props) {
  const img = "https://store.lenken.com.ar/img/";

  useEffect(() => {
    var elems = document.querySelectorAll(".materialboxed");
    var instances = M.Materialbox.init(elems, {
      inDuration: 500,
      outDuration: 500,
    });
  }, []);

  useEffect(() => {
    var elems = document.querySelectorAll(".materialboxed");
    var instances = M.Materialbox.init(elems, {
      inDuration: 500,
      outDuration: 500,
    });
  }, []);

  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  return (
    <>
      <Header modelos={props.modelos} />
      <div
        className="row valign-wrapper"
        style={{ backgroundColor: "silver", height: "70px" }}
      >
        <h5 style={{ fontFamily: "Audi Extended", paddingLeft: "5%" }}>
          Imagenes
        </h5>
      </div>
      <div
        className="li-version truncate center-align"
        style={{ fontWeight: "bold", fontSize: "15px", marginBottom: "10px" }}
      >
        clic en la imagen para ampliar y reducir
      </div>
      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s12 m12 l12">
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto0}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto1}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto2}
              alt="vehiculo seleccionado"
            />
          </div>
        </div>
      </div>

      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s12 m12 l12">
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto3}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto4}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto5}
              alt="vehiculo seleccionado"
            />
          </div>
        </div>
      </div>

      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s12 m12 l12">
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto6}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto7}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto8}
              alt="vehiculo seleccionado"
            />
          </div>
        </div>
      </div>

      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s12 m12 l12">
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto9}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto10}
              alt="vehiculo seleccionado"
            />
          </div>
          <div className="col s12 m4 l4 fotoGastos">
            <img
              className="responsive-img materialboxed"
              style={{ width: "650" }}
              src={img + props.vehiculo.foto11}
              alt="vehiculo seleccionado"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div className="center-align">
          <Link
            className="hoverable white-text center"
            onClick={scrollTop}
            style={{
              padding: "5px 10px 5px 10px",
              height: "30px",
              marginTop: "5px",
              fontFamily: "Audi Extended",
              backgroundColor: "black",
            }}
            to="/"
          >
            <b>volver</b>
          </Link>
        </div>
      </div>

      <div
        className="li-version truncate center-align"
        style={{ fontWeight: "bold", fontSize: "12px" }}
      >
        *Fotos no contractuales
      </div>
    </>
  );
}
